import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';

export const FlexWrapper = styled(Flex)`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
`;
